import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "../factory";
export const MasterProfQualificationApprovalReasonFragment = gql `
  fragment _ on ProfQualificationApprovalReason {
    id
    name
    rank
    description
    useAsDefault
    status
  }
`;
export function useProfQualificationApprovalReasonHelper() {
    function getProfQualifications() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterProfQualificationApprovalReason {
            profQualificationApprovalReasons {
              ${MasterProfQualificationApprovalReasonFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.profQualificationApprovalReasons) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, activeEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getProfQualifications);
    /**
     * Returns the first object with useAsDefault from active approval reasons
     * @param fieldName
     * @returns null, profQualificationApprovalReason object or when fieldName given then its property value
     */
    function getFirstDefaultApprovalReason(fieldName) {
        var _a;
        const foundDefault = (_a = activeEntities.value.find(x => x.useAsDefault === true)) !== null && _a !== void 0 ? _a : null;
        if (foundDefault && fieldName) {
            return foundDefault[fieldName];
        }
        return foundDefault;
    }
    return {
        masterProfQualificationApprovalReasons: masterdataEntities,
        masterProfQualificationApprovalReasonsActive: activeEntities,
        getProfQualificationApprovalReasonFromMaster: getFromMasterdata,
        withMissingProfQualificationApprovalReasonSelect: addMissingSelectValue,
        getFirstDefaultApprovalReason
    };
}
